import React, { FC, PropsWithChildren, ReactElement, useCallback } from "react";
import { useStore } from "store";
import { cn } from "helpers/style";
import styles from "./MobileMenuTrigger.module.scss";

type Props = PropsWithChildren<{
  active?: boolean;
  onClick?: () => void;
  className?: string;
}>;

const MobileMenuTrigger: FC<Props> = ({
  active,
  onClick,
  className,
  children,
}): ReactElement => {
  const { header } = useStore();
  const onClickCallback = useCallback(() => {
    onClick ? onClick() : header.openMenuMobile();
  }, [onClick, header]);

  return (
    <div
      className={cn([
        styles.mobileMenuTrigger,
        (header.menuMobileOpen || active) && styles.active,
        className,
      ])}
      onClick={onClickCallback}
    >
      <span />
      {children}
    </div>
  );
};

export default MobileMenuTrigger;
